"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_VISIBLE_PURCHASE_MOTIONS = void 0;

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var MAX_VISIBLE_PURCHASE_MOTIONS = function MAX_VISIBLE_PURCHASE_MOTIONS(hub, isMon305Variant) {
  return hub === _Hubs.default.HUB_CMS || isMon305Variant ? 3 : 2;
};

exports.MAX_VISIBLE_PURCHASE_MOTIONS = MAX_VISIBLE_PURCHASE_MOTIONS;